export const screenSizes = {
  mobile: 480,
  tablet: 800,
};
